export default __webpack_public_path__ + "static/rewards-header-logo-c69d71fa22202fb3763d024e85018fc9.png";